export const team = [
    {
        name:'Sebastian Fitzgerald',
        title:'Photographer',
        image:process.env.PUBLIC_URL + '/company/seb.jpg'
    },
    {
        name:'Madison Cole',
        title:'Events Coordinator',
        image:process.env.PUBLIC_URL + '/company/madisoncole.jpg'
    },
    {
        name:'Luca Daprano',
        title:'Operations Coordinator',
        image:process.env.PUBLIC_URL + '/company/luca.jpg'
    },
    {
        name:'Lakenna Twigg',
        title:'Social Media Coordinator',
        image:process.env.PUBLIC_URL + '/company/lakennatwigg.jpg'
    },
    {
        name:'Jeremy Reiss',
        title:'Talent Coordinator',
        image:process.env.PUBLIC_URL + '/company/jeremyreiss.jpg'
    },
    {
        name:'Brooke Dougherty',
        title:'Marketing Coordinator',
        image:process.env.PUBLIC_URL + '/company/brookedougherty.jpg'
    },
]